import { useQuery } from "@apollo/client/react";

import { signInWithRedirect } from "aws-amplify/auth";
import { useEffect, useCallback } from "react";
import { useNavigate, useLocation, Location } from "react-router";

import { AuthContainerTmp as Component } from "../../../components/pages/auth/AuthContainerTmp";
import { GET_APP_STATE } from "../../../graphql/queries";
import { LocalQuery } from "../../../cache";
import { NotFoundPage } from "../../../components/pages/NotFoundPage";
import { AWS_AUTH_IDP } from "../../../settings";
import { AuthContext } from "../../../hooks/useAuthentication";
import { use } from "react";

// ログイン周りの各画面の遷移を管理するコンポネント
export function AuthContainer() {
  const navigate = useNavigate();
  const location: Location<{ from: Location<unknown> } | undefined> =
    useLocation();

  const { auth } = use(AuthContext);
  const { data: appData } = useQuery<LocalQuery>(GET_APP_STATE);
  const { isNotSameSubDomain } = appData?.appState || {
    isNotSameSubDomain: false,
  };

  const handleSSOLogin = useCallback(() => {
    const from = location.state?.from;
    const customState = from
      ? {
          redirectTo: encodeURIComponent(
            from.pathname + from.search + from.hash,
          ),
        }
      : undefined;
    signInWithRedirect({
      provider: { custom: AWS_AUTH_IDP },
      // ログイン成功後のリダイレクト先をcustomState経由で渡し、Hubのlistenerで受け取る
      customState: JSON.stringify(customState),
    });
  }, [location]);

  useEffect(() => {
    if (auth.isLoggedIn) {
      navigate(location.state?.from ?? "/", { replace: true });
    }
  }, [auth, navigate, location]);

  if (isNotSameSubDomain) {
    return <NotFoundPage />;
  }

  return <Component onSSOLoginClick={handleSSOLogin} />;
}
